"use client";

import { PropsWithChildren, useRef } from "react";
import { MenuIcon, XIcon } from "lucide-react";
import { Drawer, Portal } from "@chakra-ui/react";

const MenuToggle: React.FC<PropsWithChildren> = ({ children }) => {
  const mobileNavToggleRef = useRef<HTMLButtonElement>(null);

  return (
    <Drawer.Root
      placement="end"
      finalFocusEl={() => mobileNavToggleRef.current}
    >
      <Drawer.Trigger asChild display={["flex", null, "none"]}>
        <button ref={mobileNavToggleRef} aria-label="Open navigation menu">
          <MenuIcon size={32} />
        </button>
      </Drawer.Trigger>

      <Portal>
        <Drawer.Backdrop />
        <Drawer.Positioner>
          <Drawer.Content>
            <Drawer.CloseTrigger>
              <XIcon />
            </Drawer.CloseTrigger>
            <Drawer.Body>{children}</Drawer.Body>
          </Drawer.Content>
        </Drawer.Positioner>
      </Portal>
    </Drawer.Root>
  );
};

export default MenuToggle;
